import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { ActionType } from 'typesafe-actions'
import { DeliveryRatingActionTypes } from './types'
import { sendRating, validateRating } from './service'
import { ratingCreateResponse, ratingValidateFailed, ratingValidateResponse } from './actions'

function* handleRatingValidation(action: ActionType<any>) {
  try {
    const { token } = action.payload
    const { status } = yield call(validateRating, token)
    yield put(ratingValidateResponse(status))
  } catch (error) {
    yield put(ratingValidateFailed())
  }
}

function* handleRatingCreation(action: ActionType<any>) {
  try {
    const { token, rating } = action.payload
    const { status } = yield call(sendRating, token, rating)
    yield put(ratingCreateResponse(status))
  } catch (e) {
    yield put(ratingValidateFailed())
  }
}

function* watchReschedule() {
  yield takeEvery(DeliveryRatingActionTypes.RATING_VALIDATE, handleRatingValidation)
  yield takeEvery(DeliveryRatingActionTypes.RATING_CREATE, handleRatingCreation)
}

function* DeliveryRatingSaga() {
  yield all([fork(watchReschedule)])
}

export default DeliveryRatingSaga
